import { Box, ButtonBase, TextField } from "@mui/material";
import React, { useState } from "react";
import { sendInviteModalStyles } from "./styles";
import EmailIcon from "@mui/icons-material/Email";
import DeleteIcon from "@mui/icons-material/Delete";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { sendInvite } from "../../services/sendInviteService";
import { toast } from "react-toastify";
import { SendInviteResponse } from "../../proto/api_pb";
import CloseIcon from "@mui/icons-material/Close";
import { SendInviteModalProps } from "./types";
import Mixpanel from "../../utils/mixpanel";
import { Button, Dialog } from "../ui";

export const SendInviteModal: React.FC<SendInviteModalProps> = ({
  isSendInviteModalOpen,
  setIsSendInviteModalOpen,
  userId,
}) => {
  const [email, setEmail] = useState<string>("");
  const [listOfMails, setListOfMails] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { getValidAccessToken } = useGetValidAccessToken();

  const handleAddEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
      setListOfMails([...listOfMails, email]);
      setEmail("");
    } else {
      toast.warning("Invalid email address");
    }
  };

  const handleDeleteEmail = (email: string) => {
    const newList = listOfMails.filter((el) => el !== email);
    setListOfMails(newList);
  };

  const handleSendInvite = async () => {
    setLoading(true);
    const accessToken = await getValidAccessToken();
    const response = await sendInvite(accessToken, listOfMails, userId);
    if (response instanceof SendInviteResponse) {
      setIsSendInviteModalOpen(false);
      setLoading(false);
      Mixpanel.track("invite_friends_success", { count: listOfMails.length });
      toast.success("Invited successfully");
    } else {
      setLoading(false);
      Mixpanel.track("invite_friends_failure");
      toast.error("Error while inviting");
    }
  };

  return (
    <Dialog.Root
      open={isSendInviteModalOpen}
      onOpenChange={(o) => {
        if (!o) setIsSendInviteModalOpen(false);
      }}
    >
      <Dialog.Content className="max-w-[500px]" aria-describedby={undefined}>
        <Box sx={{ padding: "20px" }}>
          <Box sx={{ display: "flex" }}>
            <Box sx={{ width: "90%", textAlign: "center" }}>
              <Dialog.Title className="text-[20px] font-medium text-body">
                Invite Friends to OmMuse
              </Dialog.Title>
            </Box>
            <ButtonBase onClick={() => setIsSendInviteModalOpen(false)}>
              <CloseIcon />
            </ButtonBase>
          </Box>
          <Box>
            <Box>
              {listOfMails.length > 0 &&
                listOfMails.map((el, i) => {
                  return (
                    <Box style={sendInviteModalStyles.emailContainer} key={i}>
                      <Box>
                        <EmailIcon
                          sx={{ marginRight: "10px", padding: "2px" }}
                        />
                        {el}
                      </Box>
                      <ButtonBase onClick={() => handleDeleteEmail(el)}>
                        <DeleteIcon />
                      </ButtonBase>
                    </Box>
                  );
                })}
            </Box>
            <Box sx={sendInviteModalStyles.AddEmailContainer}>
              <TextField
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                id="outlined-basic"
                label="Email"
                variant="outlined"
                type="email"
                sx={{ margin: "20px 10px" }}
              />
              <Button
                variant="primary"
                onClick={handleAddEmail}
                disabled={email === ""}
              >
                Add
              </Button>
            </Box>
            <Box sx={sendInviteModalStyles.sendInviteButtonContainer}>
              <Button
                variant="primary"
                fullWidth
                disabled={listOfMails.length === 0}
                loading={loading}
                onClick={handleSendInvite}
              >
                Send Invites
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog.Content>
    </Dialog.Root>
  );
};
